
export const validClaimNumber = ( claimNumber: string ) => {
  return claimNumber.match(/^\d{9}-\d{4}$/) ? false : true; //This is only numbers.  
};
